export default __webpack_public_path__ + "static/media/bg_1960.108e195a.png";